






















import {
  defineComponent,
  getCurrentInstance,
  ref,
  PropType,
} from '@vue/composition-api'
import { ApolloError, NetworkStatus } from 'apollo-client'

import CustomSelectTemplate from '@/components/organisms/h/item/hierarchy/CustomSelectTemplate.vue'
import {
  emitHierarchySelect,
  itemHierarchyType,
  emitHierarchySearch,
  emitCustomSelectSelect,
} from '@/types/entities'
import {
  SaleItemsDocument,
  AllSaleitemMstEdge,
  Where,
} from '@/types/generated/graphql'
import { MAX_COUNT } from '@/utils/constant'
import Toast, { genNotifyMessage } from '@/utils/toast'

export default defineComponent({
  components: { CustomSelectTemplate },
  props: {
    where: {
      type: Array as PropType<Where[]>,
      default: () => [],
    },
    itemHierarchyType: {
      type: String as PropType<itemHierarchyType>,
      default: '',
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    notHierarchicalItem: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  apollo: {
    saleItems: {
      query: SaleItemsDocument,
      variables() {
        return this.searchCond
      },
      skip: true,
      fetchPolicy: 'cache-and-network',
      error(e: ApolloError) {
        Toast.error(this, { message: genNotifyMessage('e.list', 'item', e) })
      },
    },
  },
  created() {
    // 単品の場合は初期状態でクエリの検索をしない
    // this.$apollo.queries.saleItems.skip = false
    // this.isSkipQuery = false
  },
  data() {
    return {
      saleItems: { edges: [] },
      // 表示を制御するためのフラグ（データを触ると想定しない挙動となるため用意した）
      isSkipQuery: true,
      totalCount: 0,
      first: MAX_COUNT,
    }
  },
  computed: {
    isLoading() {
      return this.$apollo.queries.saleItems.loading
    },
    saleItemList() {
      // 商品一覧
      return this.saleItems.edges.map((ele: AllSaleitemMstEdge) => {
        return {
          value: ele.node?.saleItemCd,
          text: ele.node?.saleItemName,
          key: ele.node?.saleItemCd,
        }
      })
    },
    searchCond(props: any) {
      return {
        where: props.where,
        orderBy: [],
        first: this.first,
      }
    },
    custumEmptyText() {
      if (this.where.length === 0 && !this.notHierarchicalItem) {
        return this.$i18n.t('description.no-where-cond-tanpin')
      } else if (this.where.length === 0 && this.notHierarchicalItem) {
        return this.$i18n.t('description.no-where-cond-tanpin-not-hierarchical')
      } else {
        return ''
      }
    },
  },
  watch: {
    where(newVal) {
      this.resetFirst()
      console.log('単品 where=', newVal)
      if (newVal.length !== 0) {
        // 検索条件が設定されたら検索ON
        this.$apollo.queries.saleItems.skip = false
        this.isSkipQuery = false
      } else {
        // 検索条件がない場合は検索しない。
        this.$apollo.queries.saleItems.skip = true
        this.isSkipQuery = true
      }
    },
    saleItems(data) {
      this.totalCount = this.saleItems.totalCount
    },
  },
  methods: {
    changeSelected(emitParams: emitCustomSelectSelect) {
      const setectedMetaInfo = this.saleItems.edges.filter(
        (ele: AllSaleitemMstEdge) => {
          const key = ele.node?.saleItemCd
          if (key) {
            for (const selKey of emitParams.keyList) {
              if (selKey.indexOf(key) !== -1) {
                return true
              }
            }
          }
        }
      )
      const params: emitHierarchySelect = {
        itemHierarchyType: 'Tanpin',
        selected: emitParams.selectList,
        selectedCount: emitParams.selectedCount,
        setectedMetaInfo: setectedMetaInfo,
      }
      this.$emit('change-selected', params)
    },
    onSearchWord(params: emitHierarchySearch) {
      console.log('search-word')
      this.$emit('search-word', params)
    },
    onSearch(params: emitHierarchySearch) {
      this.$emit('search', params)
    },
    countOverOk(params: any) {
      this.first = params
    },
    resetFirst() {
      this.first = MAX_COUNT
    },
  },
})
